/* eslint-disable no-console */
import type { MetricsAdapter } from '../Metrics';

const consoleAdapter = (): MetricsAdapter => {
  return {
    setUser: (user) => {
      console.log(
        `%c METRIC setUser %c ${user?.name}`,
        'color: white; background-color: green;',
        'font-weight: normal;'
      );
    },
    logDuration: (name, options = {}) => {
      let desc = options.description ? ` (${options.description})` : '';
      if (options.context) {
        desc += ` ${JSON.stringify(options.context)}`;
      }
      return (_start, duration) => {
        console.log(
          `%c METRIC ${duration.toFixed(3)}ms %c ${name}%c${desc}`,
          'color: white; background-color: green;',
          'font-weight: bold;',
          'color:cyan'
        );
      };
    },
    setViewName: (name: string) => {
      console.log('view name', name);
    },
    logEvent: (data) => {
      const { name, ...context } = data;
      console.log(
        `%c METRIC %c ${name}%c ${JSON.stringify(context ?? {})}`,
        'color: white; background-color: green;',
        'font-weight: bold;',
        'color:cyan'
      );
    },
    logWarning: (message, options) => {
      console.warn(
        `%c METRIC WARNING %c ${message}%c ${JSON.stringify(options ?? {})}`,
        'color: white; background-color: darkgoldenrod;',
        'font-weight: bold;',
        'color:cyan'
      );
    },
    logError: (error, options = {}) => {
      console.error(
        `%c METRIC ERROR %c ${error.name} ${error.message}%c ${JSON.stringify(options ?? {})}`,
        'color: white; background-color: red;',
        'font-weight: bold;',
        'color:cyan'
      );
    },
  };
};

export default consoleAdapter;
